import { demoData } from "../../utils/constants/demoAccountData";
import {
  // Switch between live and demo account
  SWITCH_ACCOUNT_TYPE,
  // Types for Dashboard
  GET_INSIGHT_1,
  GET_SALES_DATA,
  GET_ORDERS_DATA,
  GET_POPULAR_TIME,
  SET_REPORT_STATUS,
  SET_UPCOMING_CELEBRATIONS,
  GET_POPULAR_ITEMS_AND_CATEGORIES,
  // Types for campaign Performance
  SET_CAMP_PERF_OVERVIEW,
  SET_CAMP_LIST,
  // Customer Insights
  SET_KYC_DATA,
  SET_SNAPSHOT_DATA,
  SET_NEW_RETURN_LOST_CUST,
  GET_CUSTOMERS_SEGMENT,
  GET_CUSTOMERS_TABLE_SEGMENT,
  SET_CUSTOMERS_ACTIVITY,
  GET_LOYALTY_INSIGHTS,
  GET_LOYALTY_PERF_INSIGHTS,
  SET_LOYALTY_DATA,
  SET_AUTO_CAMPAIGN_OVERVIEW,
  FEEDBACK_OVERVIEW,
  FEEDBACK_RATINGS_OVERTIME,
  FEEDBACK_DAILY_RESPONSES,
  SET_FB_RES_DATA,
  SET_GENERAL_DASH_STATS,
} from "../types";
import { setRecommendedSegments } from "./audienceRecommendationActions";

export const switchAccountType = (data) => (dispatch) => {
  dispatch({
    type: SWITCH_ACCOUNT_TYPE,
    payload: data,
  });
};

// dashboard actions for demo account

const setDashInsight1 = (data) => (dispatch) => {
  dispatch({
    type: GET_INSIGHT_1,
    payload: data,
  });
};

const setSalesData = (data) => (dispatch) => {
  dispatch({
    type: GET_SALES_DATA,
    payload: data,
  });
};

const setOrdersData = (data) => (dispatch) => {
  dispatch({
    type: GET_ORDERS_DATA,
    payload: data,
  });
};

const setPopularTime = (data) => (dispatch) => {
  dispatch({
    type: GET_POPULAR_TIME,
    payload: data,
  });
};
const setGeneralStats = (data) => (dispatch) => {
  dispatch({
    type: SET_GENERAL_DASH_STATS,
    payload: data,
  });
};

const setPopularItemsAndCategories = (data) => (dispatch) => {
  dispatch({
    type: GET_POPULAR_ITEMS_AND_CATEGORIES,
    payload: data,
  });
};

const setUpcomingCelebrations = (data) => (dispatch) => {
  dispatch({
    type: SET_UPCOMING_CELEBRATIONS,
    payload: data,
  });
};

const setReportStatus = (data) => (dispatch) => {
  dispatch({
    type: SET_REPORT_STATUS,
    payload: data,
  });
};

export const handleDemoDashboard = () => (dispatch) => {
  dispatch(setDashInsight1(demoData.dashboard.hlAndFreq || {}));
  dispatch(setSalesData(demoData.dashboard.sales || []));
  dispatch(setOrdersData(demoData.dashboard.orders || []));
  dispatch(setPopularTime(demoData.dashboard.time || {}));
  dispatch(setGeneralStats(demoData.dashboard.generalStats || {}));
  dispatch(
    setPopularItemsAndCategories(demoData.dashboard.popularItemsAndCate || {})
  );
  dispatch(
    setUpcomingCelebrations(demoData.dashboard.upcomingCelebrations || {})
  );
  dispatch(setReportStatus(demoData.dashboard.reportStatus || {}));
  dispatch(setRecommendedSegments(true, demoData.audienceRecs.dashboardSegments));
};

// campaign performance
const setCampPerfOverview = (data) => (dispatch) => {
  dispatch({
    type: SET_CAMP_PERF_OVERVIEW,
    payload: data,
  });
};

const setCampListing = (data) => (dispatch) => {
  dispatch({
    type: SET_CAMP_LIST,
    payload: data,
  });
};

export const handleDemoCampaignOverview = () => (dispatch) => {
  dispatch(setCampListing(demoData.campaigns.CampList));
  dispatch(setCampPerfOverview(demoData.campaigns.CampPerformance));
};

// customer insights overview
const setKycData = (data) => (dispatch) => {
  dispatch({
    type: SET_KYC_DATA,
    payload: data,
  });
};

const setSnapshotData = (data) => (dispatch) => {
  dispatch({
    type: SET_SNAPSHOT_DATA,
    payload: data,
  });
};

const setNewReturnLostCustomers = (data) => (dispatch) => {
  dispatch({
    type: SET_NEW_RETURN_LOST_CUST,
    payload: data,
  });
};

export const handleDemoCustomerInsightsOverview = () => (dispatch) => {
  dispatch(setKycData(demoData.customerInsights.kycData));
  dispatch(setSnapshotData(demoData.customerInsights.snapShotData));
  dispatch(setNewReturnLostCustomers(demoData.customerInsights.custGraphData));
};

// customer insights segments

const setCustomerSegments = (data) => (dispatch) => {
  dispatch({
    type: GET_CUSTOMERS_SEGMENT,
    payload: data,
  });
};

const setCustomerTableSegments = (data) => (dispatch) => {
  dispatch({
    type: GET_CUSTOMERS_TABLE_SEGMENT,
    payload: data,
  });
};

export const handleDemoSegmentsData = () => (dispatch) => {
  dispatch(setCustomerSegments(demoData.customerInsights.custSegm));
  dispatch(setCustomerTableSegments(demoData.customerInsights.custTableSegm));
};

// customer list actions

export const handleDemoCustomerList = () => {
  return {
    customerListData: demoData.customerInsights.custList,
    dynamicFilterVals: demoData.customerInsights.dynamicFilterVals,
  };
};

// customer activity

export const setDemoCustomersActivity = () => (dispatch) => {
  dispatch({
    type: SET_CUSTOMERS_ACTIVITY,
    payload: demoData.customerInsights.custActivity,
  });
};

// loyalty

const setLoyaltyInsights = (data) => (dispatch) => {
  dispatch({
    type: GET_LOYALTY_INSIGHTS,
    payload: data,
  });
};

const setLoyaltyPerf = (data) => (dispatch) => {
  dispatch({
    type: GET_LOYALTY_PERF_INSIGHTS,
    payload: data,
  });
};

const setDemoLoyalty = (data) => (dispatch) => {
  dispatch({
    type: SET_LOYALTY_DATA,
    payload: data,
  });
};

export const handleDemoLoyaltyData = () => (dispatch) => {
  dispatch(setLoyaltyInsights(demoData.loyalty.loyaltyInsights));
  dispatch(setLoyaltyPerf(demoData.loyalty.loyaltyPerf));
  dispatch(setDemoLoyalty(demoData.loyalty.loyaltyData));
};

// auto-campaigns

const autoCampaignOverview = (data) => (dispatch) => {
  dispatch({
    type: SET_AUTO_CAMPAIGN_OVERVIEW,
    payload: data,
  });
};

export const handleDemoAutoCampaignOverview = () => (dispatch) => {
  dispatch(autoCampaignOverview(demoData.autoCampaigns.overview));
};

// feedback

const setFeedbackOverview = (data) => (dispatch) => {
  dispatch({
    type: FEEDBACK_OVERVIEW,
    payload: data,
  });
};
const setFbRatingsOvertime = (data) => (dispatch) => {
  dispatch({
    type: FEEDBACK_RATINGS_OVERTIME,
    payload: data,
  });
};
const setFbDailyResponses = (data) => (dispatch) => {
  dispatch({
    type: FEEDBACK_DAILY_RESPONSES,
    payload: data,
  });
};
const setFbData = (data) => (dispatch) => {
  dispatch({
    type: SET_FB_RES_DATA,
    payload: data,
  });
};

export const handleDemoFeedback = () => (dispatch) => {
  dispatch(setFbData(demoData.feedback.fbResData));
  dispatch(setFeedbackOverview(demoData.feedback.overview));
  dispatch(setFbRatingsOvertime(demoData.feedback.ratingOverTime));
  dispatch(setFbDailyResponses(demoData.feedback.dailyResponses));
};
